import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
export const DotIndicatorDot = ({ isActive, isInView, isEdge, }) => {
    const getScale = () => {
        if (isEdge)
            return 0.5;
        if (isInView || isActive)
            return 1;
        return 0.5;
    };
    return (_jsx(Box, { "data-testid": "dot-indicator-dot", tabIndex: 0, onKeyDown: e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
            }
        }, sx: {
            flex: '0 0 8px',
            height: 8,
            width: 8,
            transform: `scale(${getScale()})`,
            borderRadius: isActive ? '8px' : '4px',
            backgroundColor: isActive ? '#0090E3' : '#999999',
            opacity: isActive ? 0.8 : isInView ? 0.6 : 0.6,
            transition: 'opacity 0.4s cubic-bezier(0.4,0,0.2,1), transform 0.4s cubic-bezier(0.4,0,0.2,1), background-color 0.2s',
            '&:focus-visible': {
                outline: '2px solid #1a73e8',
                outlineOffset: '2px',
            },
        } }));
};
//# sourceMappingURL=DotIndicatorDot.js.map